import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { AccountAdministrationView } from './administration/administration';
import { AccountCompanyView } from './company/company';
import { AccountControllerModule } from './controllers/AccountController';
import { AccountProfileView } from './profile/profile';

export const AccountView = angular
  .module('acme.view.application.account', [
    uiRouter,
    'ui.bootstrap',
    AccountControllerModule,
    AccountProfileView,
    AccountCompanyView,
    'acme.view.application.account.departments',
    AccountAdministrationView,
    'acme.view.application.account.configuration',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.account',
      url: '/account',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'AccountController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/account/account.tpl.html',
        },
      },
      data: {
        pageTitle: ' ',
      },
    });
  }).name;
